import { API_URL, requestData } from "./utils";
// I hate that we call these "modules." This is not a module.
const apiPath = "/profanity";
const profanityEntriesPath = `${apiPath}/profanity-filter-entries`;
const profanityEntriesQueryPath = `${apiPath}/query/profanity-filter-entries`;
const profanityListIdPath = `${apiPath}/sys/all-valid-profanity-filter-ids`;
const antiSpamRulesPath = `${apiPath}/anti-spam-rules`;

interface ProfanityFilterEntry {
  type: string;
  value: string;
}

interface AddProfanityFilterRequest {
  profanity_filter_entry: ProfanityFilterEntry;
}

export default class ProfanityClient {
  addProfanityRule(request: AddProfanityFilterRequest, listId = "global-mt") {
    return requestData("POST", `${profanityEntriesPath}/${listId}`, request);
  }
  deleteProfanityRule(listId: string, type: string, value: string) {
    return requestData(
      "DELETE",
      `${profanityEntriesPath}/${listId}/${type}/${value}`,
    );
  }
  getProfanityEntries(query) {
    return requestData("GET", profanityEntriesQueryPath, query);
  }
  getProfanityListIds() {
    return requestData("GET", profanityListIdPath);
  }
  getAntiSpamRules() {
    return requestData("GET", antiSpamRulesPath);
  }
  
  getProfanityCsvURL(query, listId = "global-mt", link: string = `${profanityEntriesPath}/${listId}`) {
    return API_URL + link + "?" + new URLSearchParams(query);
  }
}
